import Bills from '../Bills.vue'
import BillsList from '../Views/BillsList.vue'

const BillsRoutes = {
    path: '/bills',
    meta: {
        name: {
            en: 'Bills',
            es: 'Facturas'
        }
    },
    component: Bills,
    children: [
        {
            path: '/',
            component: BillsList,
            name: 'BillsList',
        }
    ]
}

export default BillsRoutes